[
  {
    "image": "saccarinesunshine.jpg",
    "title": "Saccharine Sunshine",
    "artist": "MC Gill",
    "date": "September, 2026",
    "credits": "MaryCatherine Arrington Gill, composer, songwriter. Elijah Boisvert, producer.",
    "artistLink": "https://open.spotify.com/artist/5J4AoKjA1IyZa4TrkbSaOa?si=8JqejM8DRXyIlCiqi3p3Pw",
    "productionLink": "https://open.spotify.com/album/2XdnFbmvXmVuX7uRJEPn8b?si=48yVtCZpTriZRhlwuMEpPw",
    "type": "Single"
  },
  {
    "image": "honey.jpg",
    "title": "Don't say it to me, honey.",
    "artist": "O'Leyra",
    "date": "May, 2026",
    "credits": "Katherine O'Leary, composer, songwriter, producer. Elijah Boisvert, composer, songwriter, producer.",
    "artistLink": "https://open.spotify.com/artist/3iHisiPd98GyYi6eUNz5kL?si=77d5bd3d78a145fe",
    "productionLink": "https://open.spotify.com/album/0cakP3PZBsAxjoaEjpKNPT?si=3uftUpMtQfigOiWdVN967Q",
    "type": "Single"
  },
  {
    "image": "rosy.jpg",
    "title": "roSy",
    "artist": "Sadie Grace Fay",
    "date": "April, 2026",
    "credits": "Sadie Fay, songwriter. Elijah Boisvert, composer, producer.",
    "artistLink": "https://open.spotify.com/artist/4PIcFhZyKGhwFyPXTXQaCe?si=DDNc__ueQm6nAzdU4YZTQQ",
    "productionLink": "https://open.spotify.com/album/3dxfD2jEcil1TjxTCr7EF8?si=Vu9imiYHRPeDsuvswGtvYQ",
    "type": "Single"
  },
  {
    "image": "watchyouleave.jpg",
    "title": "watch you leave",
    "artist": "Joshua Tu (杜璟瑜)",
    "date": "April, 2026",
    "credits": "Joshua Tu, composer, co-producer. Elijah Boisvert, composer, songwriter, co-producer. Pamela Martinez, trumpet performance.",
    "artistLink": "https://open.spotify.com/artist/1Zn7PRCCAnBZDSgskEbXBZ?si=Gi92tivhQheqOWpzqiBhgQ",
    "productionLink": "https://open.spotify.com/album/7Kxx86jFThGkFI0lPivCuC?si=V2j2k5SAReGgGfxRRuF0hA",
    "type": "Single"
  },
  {
    "image": "wgbu.jpg",
    "title": "What Grows Beneath Us",
    "artist": "Elijah Blue",
    "date": "April, 2026",
    "credits": "Elijah Boisvert, composer, songwriter, producer.",
    "artistLink": "https://open.spotify.com/artist/3XTgNKuTD53L6AeUqYoXUA?si=Gclni271SQu8OfSZbDkemg",
    "productionLink": "https://distrokid.com/hyperfollow/elijahblue2/what-grows-beneath-us",
    "type": "Album",
    "featured": "true"
  },
  {
    "image": "iseemtohavelost.jpg",
    "title": "Oh I seem to have lost.",
    "artist": "O'Leyra",
    "date": "March, 2026",
    "credits": "Katherine O'Leary, composer, songwriter, producer. Elijah Boisvert, producer, composer.",
    "artistLink": "https://open.spotify.com/artist/3iHisiPd98GyYi6eUNz5kL?si=77d5bd3d78a145fe",
    "productionLink": "https://open.spotify.com/album/0FCJNjTzJlkKcNDMCRzmYG?si=Dpt3PntPSA2WK4Kn2agHfg",
    "type": "Single"
  },
  {
    "image": "embers.jpg",
    "title": "Embers",
    "artist": "Atlantic Abandon",
    "date": "March, 2026",
    "credits": "Hunter Bolduc, composer, songwriter. Emma Platte, composer, songwriter. Elijah Boisvert, producer.",
    "artistLink": "https://open.spotify.com/artist/3kk9fqe0oJjC43yUObCUzw?si=2lFG7tf3TjeaSDA9etqf_w",
    "productionLink": "https://open.spotify.com/album/7IiNfHaz8epZjpxdz1gsWG?si=0o5-H-zWRY2b9uBXwoL8Jw",
    "type": "EP"
  },
  {
    "image": "mci.jpg",
    "title": "MCI (Springtrap Please)",
    "artist": "Fazwolf Pack",
    "date": "December, 2025",
    "credits": "Emily Query, songwriter. Elijah Boisvert, composer, songwriter, producer.",
    "artistLink": "https://open.spotify.com/artist/4RcOFk4xHA4cqkCBdYhv7F?si=xpaL0jN-Rkit5ho4NdV_nQ",
    "productionLink": "https://open.spotify.com/album/5I0plqpTbH1lyEXf2L92Ch?si=13QPHWu3T_2XUtQ0P6L4-g",
    "type": "Single"
  },
  {
    "image": "bones2025.jpg",
    "title": "Jingle Bones: The Bones are Back for Christmas",
    "artist": "The Bones",
    "date": "December, 2025",
    "credits": "Elijah Boisvert, producer.",
    "artistLink": "https://open.spotify.com/artist/2QMa0L7N1O03OoyPy7H0TM",
    "productionLink": "https://open.spotify.com/album/2C8TerngQCKmW9orwdaImY?si=3jL-v9-kTfiWZYRfrQAMYA",
    "type": "Album"
  },
  {
    "image": "howithurts.jpg",
    "title": "How it Hurts, How it Heals",
    "artist": "O'Leyra",
    "date": "November, 2025",
    "credits": "Katherine O'Leary, composer, songwriter, producer. Elijah Boisvert, producer, composer.",
    "artistLink": "https://open.spotify.com/artist/3iHisiPd98GyYi6eUNz5kL?si=77d5bd3d78a145fe",
    "productionLink": "https://open.spotify.com/album/28GoztnhbKKdr7HpqzfNTP?si=mTqLl7npQEaae1VL4nfU4A",
    "type": "Album"
  },
  {
    "image": "tobehonest.jpg",
    "title": "To Be Honest",
    "artist": "Catie Verostick",
    "date": "October, 2025",
    "credits": "Catie Verostick, composer, songwriter. Elijah Boisvert, producer.",
    "artistLink": "https://open.spotify.com/artist/15q9cNtp95phFGek12COqH?si=CbJBFT58TPa9YPZ38a-HVQ",
    "productionLink": "https://open.spotify.com/album/7lZj5ybtL1tIjAVr1Y4G0H?si=zvZw2gLnRzCX-xmh6nFejw",
    "type": "EP"
  },
  {
    "image": "holding.png",
    "title": "Holding",
    "artist": "Wounded World",
    "date": "September, 2025",
    "credits": "David Breen, composer, songwriter. Elijah Boisvert, producer.",
    "artistLink": "https://open.spotify.com/artist/4CohEzr6Gt1YsDj6KgcRWG?si=cb273a749fba41ab",
    "productionLink": "https://open.spotify.com/album/7chWXMMVhFH6BUtDTNKtKj?si=XgcWtzMYSkSXRVdudHQwKQ",
    "type": "Single"
  },
  {
    "image": "scarybear.jpg",
    "title": "Scary Bear",
    "artist": "Fazwolf Pack",
    "date": "August, 2025",
    "credits": "Emily Query, songwriter. Elijah Boisvert, composer, songwriter, producer.",
    "artistLink": "https://open.spotify.com/artist/4RcOFk4xHA4cqkCBdYhv7F?si=xpaL0jN-Rkit5ho4NdV_nQ",
    "productionLink": "https://distrokid.com/hyperfollow/fazwolfpack/scary-bear",
    "type": "Single"
  },
  {
    "image": "arriving.png",
    "title": "Arriving Now",
    "artist": "Wounded World",
    "date": "July, 2025",
    "credits": "David Breen, composer, songwriter. Elijah Boisvert, producer.",
    "artistLink": "https://open.spotify.com/artist/4CohEzr6Gt1YsDj6KgcRWG?si=cb273a749fba41ab",
    "productionLink": "https://open.spotify.com/album/7u3ceC3aKx642XzEpA7XFj?si=ilfRGlmuTsaQ56cLmdFE_g",
    "type": "Single"
  },
  {
    "image": "trailmix.jpg",
    "title": "Trail Mix",
    "artist": "Elijah Blue",
    "date": "April, 2025",
    "credits": "Elijah Boisvert, composer, songwriter, producer.",
    "artistLink": "https://open.spotify.com/artist/3XTgNKuTD53L6AeUqYoXUA",
    "productionLink": "https://distrokid.com/hyperfollow/elijahblue2/trail-mix",
    "type": "Single"
  },
  {
    "image": "searching.png",
    "title": "Searching",
    "artist": "Wounded World",
    "date": "April, 2025",
    "credits": "David Breen, composer, songwriter. Elijah Boisvert, producer.",
    "artistLink": "https://open.spotify.com/artist/4CohEzr6Gt1YsDj6KgcRWG?si=cb273a749fba41ab",
    "productionLink": "https://open.spotify.com/album/1ZwdQnFZsrwibC4QbarYBh?si=4IxAjVnEQ6yCn-oQtQoDJQ",
    "type": "Single"
  },
  {
    "image": "bones2024.jpg",
    "title": "Christmas Classics with The Bones",
    "artist": "The Bones",
    "date": "December, 2024",
    "credits": "Elijah Boisvert, producer.",
    "artistLink": "https://open.spotify.com/artist/2QMa0L7N1O03OoyPy7H0TM",
    "productionLink": "https://distrokid.com/hyperfollow/thebones2/christmas-classics-with-the-bones",
    "type": "Album"
  },
  {
    "image": "allagain.jpg",
    "title": "do it all again",
    "artist": "Elijah Blue",
    "date": "July, 2024",
    "credits": "Elijah Boisvert, composer, songwriter, producer.",
    "artistLink": "https://open.spotify.com/artist/3XTgNKuTD53L6AeUqYoXUA",
    "productionLink": "https://distrokid.com/hyperfollow/elijahblue2/do-it-all-again",
    "type": "Single"
  },
  {
    "image": "jonathan.jpg",
    "title": "Jonathan",
    "artist": "Sadie Grace Fay",
    "date": "May, 2024",
    "credits": "Sadie Fay, songwriter. Elijah Boisvert, composer, producer.",
    "artistLink": "https://open.spotify.com/artist/4PIcFhZyKGhwFyPXTXQaCe?si=DDNc__ueQm6nAzdU4YZTQQ",
    "productionLink": "https://open.spotify.com/album/47Wo4p9TlSTBi6h5GDADvf?si=BJ9QNOKGRj2if-qgfJez3w",
    "type": "Single"
  },
  {
    "image": "grayorblue.jpg",
    "title": "Gray or Blue",
    "artist": "Alexa Rose",
    "date": "April, 2024",
    "credits": "Alexa Grant, songwriter. Elijah Boisvert, composer, producer.",
    "artistLink": "https://open.spotify.com/artist/576oHTlwaiNWuu21zSi7yE?si=yEHCD-hLR_iZ6Abk5Q_kPA",
    "productionLink": "https://open.spotify.com/album/1tmzaOyhm3GMVh7iPRBcnl?si=I1A9OJISStiEh8sMmDLD5A",
    "type": "Single"
  },
  {
    "image": "usedtobe.jpeg",
    "title": "i'm still who i used to be",
    "artist": "Elijah Blue",
    "date": "October, 2023",
    "credits": "Elijah Boisvert, composer, songwriter, producer.",
    "artistLink": "https://open.spotify.com/artist/3XTgNKuTD53L6AeUqYoXUA",
    "productionLink": "https://distrokid.com/hyperfollow/elijahblue2/im-still-who-i-used-to-be",
    "type": "Single"
  },
  {
    "image": "montauk.jpg",
    "title": "Meet Me in Montauk",
    "artist": "Elijah Blue",
    "date": "July, 2023",
    "credits": "Elijah Boisvert, composer, songwriter, producer.",
    "artistLink": "https://open.spotify.com/artist/3XTgNKuTD53L6AeUqYoXUA",
    "productionLink": "https://distrokid.com/hyperfollow/elijahblue2/meet-me-in-montauk",
    "type": "Album"
  }
]